const template = `
  query Studio($studioId: ID!) {
    studio(id: $studioId) {
      id
      name
      largeLogoUrl
      bannerUrl
      rating
      totalRatingCount
      showableStylists {
        isStudioAccount
        user {
          id
          name
          avatar
        }
      }
      studioPhotos {
        url {
          large
          small
        }
      }
      traffic
      address
    }
  }
`

export default async function studio({ studioId }) {
  const { studio } = await request(template, { studioId })
  return studio
}
